import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDQtvvKdziqcEpFfYwnGx2ASXFr2koi1wc",
  authDomain: "joynapp.com.br",
  projectId: "eventfy-ff660",
  storageBucket: "eventfy-ff660.firebasestorage.app",
  messagingSenderId: "722088048795",
  appId: "1:722088048795:web:24b60f0d6fd62704696e3e",
  measurementId: "G-EKTGD99HH3"
};

export function getFirebase() {
  return getApps()[0] || initializeApp(firebaseConfig);
}

const app = getFirebase();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
